/**
 * @generated SignedSource<<e35666f1f5dccd98c72d1ac5d6d8d6b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WelcomePopupAiAssistant202511Query$variables = {
  locator: string;
  skip: boolean;
};
export type WelcomePopupAiAssistant202511Query$data = {
  readonly userPermissions?: {
    readonly count: number | null | undefined;
  } | null | undefined;
};
export type WelcomePopupAiAssistant202511Query = {
  response: WelcomePopupAiAssistant202511Query$data;
  variables: WelcomePopupAiAssistant202511Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "locator",
            "variableName": "locator"
          },
          {
            "kind": "Literal",
            "name": "userLocator",
            "value": "current"
          }
        ],
        "concreteType": "PermissionAssignments",
        "kind": "LinkedField",
        "name": "userPermissions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WelcomePopupAiAssistant202511Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WelcomePopupAiAssistant202511Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9ecb6cca480a2a868d4cae94d961c8dd",
    "id": null,
    "metadata": {},
    "name": "WelcomePopupAiAssistant202511Query",
    "operationKind": "query",
    "text": "query WelcomePopupAiAssistant202511Query(\n  $locator: String!\n  $skip: Boolean!\n) {\n  userPermissions(userLocator: \"current\", locator: $locator) @skip(if: $skip) {\n    count\n  }\n}\n"
  }
};
})();

(node as any).hash = "e979de3fd8636f5dee9072b97e0a3799";

export default node;
